import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';
import { Box, Typography } from '@mui/material';
import { CategoryStat } from '../../types';

// Chart.jsの登録
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

interface RadarChartProps {
  radarCategoryStats: Record<string, CategoryStat>;
}

const RadarChart: React.FC<RadarChartProps> = ({ radarCategoryStats }) => {
  // カテゴリ名とスコアの準備
  const categories = Object.keys(radarCategoryStats);
  const averages = categories.map(cat => radarCategoryStats[cat].average);

  const chartData = {
    labels: categories,
    datasets: [
      {
        label: 'スキルレベル平均',
        data: averages,
        backgroundColor: 'rgba(33, 150, 243, 0.2)',
        borderColor: 'rgba(33, 150, 243, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(33, 150, 243, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(33, 150, 243, 1)'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            return `${context.label}: ${context.parsed.r.toFixed(1)}/5.0`;
          }
        }
      }
    },
    scales: {
      r: {
        beginAtZero: true,
        max: 5,
        ticks: {
          stepSize: 1
        },
        pointLabels: {
          font: {
            size: 12
          }
        }
      }
    }
  };

  return (
    <Box sx={{ height: 400, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="h6" gutterBottom>
        スキルバランス
      </Typography>
      <Box sx={{ height: 350, width: '100%', maxWidth: 400 }}>
        <Radar data={chartData} options={options} />
      </Box>
    </Box>
  );
};

export default RadarChart;
